module.exports = __webpack_public_path__ + "img/product4.460ca6ad.png";